var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden && _vm.removed.indexOf(_vm.pos) === -1)?_c('td',[_c('span',[_vm._t("default")],2)]):(_vm.hidden && _vm.removed.indexOf(_vm.pos) >= 0)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('td',[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }